/* Shreedhara Jewels — global.js */
(function () {
  'use strict';

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty-input');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    var step = parseInt(btn.dataset.qtyChange, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = min;
    val = Math.min(max, Math.max(min, val + step));
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product form: variant picker ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var selects = root.querySelectorAll('[data-option-index]');
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var btn = root.querySelector('[data-add-button]');
    var btnText = btn && btn.querySelector('span');
    var invNote = root.querySelector('[data-inventory-note]');
    var moneyFormat = dataEl.dataset.moneyFormat || '₹{{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      var parts = amount.split('.');
      // Indian digit grouping
      var x = parts[0]; var last3 = x.slice(-3); var rest = x.slice(0, -3);
      if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, parts[1] ? last3 + '.' + parts[1] : last3);
    }

    function currentVariant() {
      var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var v = currentVariant();
      if (!v) {
        if (btn) { btn.disabled = true; if (btnText) btnText.textContent = 'Unavailable'; }
        if (invNote) invNote.hidden = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.hidden = false;
        } else compareEl.hidden = true;
      }
      if (btn) {
        btn.disabled = !v.available;
        if (btnText) btnText.textContent = v.available ? (btn.dataset.addText || 'Add to cart') : (btn.dataset.soldoutText || 'Sold out');
      }
      if (invNote) {
        var qty = v.inventory_quantity;
        var show = v.available && typeof qty === 'number' && qty > 0 && qty <= 5 && v.inventory_management;
        invNote.hidden = !show;
        if (show) invNote.textContent = 'Only ' + qty + ' left in stock!';
      }
      // update URL without reload
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    if (selects.length) update();

    /* AJAX add to cart */
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn) { btn.disabled = true; if (btnText) btnText.textContent = 'Adding...'; }
        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw j; });
          return r.json();
        }).then(function () {
          return fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); });
        }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
          if (btnText) btnText.textContent = 'Added ✓';
          setTimeout(update, 1500);
        }).catch(function (err) {
          var msg = (err && (err.description || err.message)) || 'Could not add to cart.';
          var box = root.querySelector('[data-form-error]');
          if (box) { box.textContent = msg; box.hidden = false; }
          update();
        });
      });
    }
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.src = t.dataset.src;
        main.srcset = t.dataset.srcset || '';
        main.alt = t.querySelector('img') ? t.querySelector('img').alt : '';
        g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  });

  /* ---------- Cart page: auto-update on qty change ---------- */
  document.querySelectorAll('[data-cart-item-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.dataset.line;
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      if (!window.fetch) { input.form && input.form.submit(); return; }
      fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    });
  });

  /* ---------- Close dropdowns on outside click ---------- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.site-nav details[open], .site-header details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('details[open]').forEach(function (d) { d.removeAttribute('open'); });
  });
})();
